
import { useState, useEffect } from 'react';
import { Region } from '../../../data/regions';
import { Church, MissionaryRecords } from './types';

export const useMockChurchData = (region: Region) => {
  const [churches, setChurches] = useState<Church[]>([]);
  const [missionaries, setMissionaries] = useState<MissionaryRecords>({});
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Sample churches data for demonstration
    // In a real app, this would come from the database
    const sampleChurches: Church[] = [
      {
        id: '1',
        name: 'Primera Iglesia Bautista',
        denomination: 'Baptist',
        location: region.spanish_name,
        coordinates: [region.coordinates[0] - 0.2, region.coordinates[1] - 0.1],
        missionaries: 5
      },
      {
        id: '2',
        name: 'Centro Cristiano',
        denomination: 'Evangelical',
        location: region.spanish_name,
        coordinates: [region.coordinates[0] + 0.3, region.coordinates[1] + 0.2],
        missionaries: 3
      },
      {
        id: '3',
        name: 'Iglesia Pentecostal',
        denomination: 'Pentecostal',
        location: region.spanish_name,
        coordinates: [region.coordinates[0] - 0.1, region.coordinates[1] + 0.3],
        missionaries: 7
      }
    ];
    
    // Sample missionary data for demonstration
    const sampleMissionaries: MissionaryRecords = {
      '1': [
        { id: 'm1', name: 'John Smith', origin_country: 'USA', years_of_service: 7, church_id: '1' },
        { id: 'm2', name: 'Maria Rodriguez', origin_country: 'Spain', years_of_service: 5, church_id: '1' },
        { id: 'm3', name: 'David Kim', origin_country: 'South Korea', years_of_service: 3, church_id: '1' }
      ],
      '2': [
        { id: 'm4', name: 'James Wilson', origin_country: 'Canada', years_of_service: 4, church_id: '2' },
        { id: 'm5', name: 'Anna Chen', origin_country: 'China', years_of_service: 2, church_id: '2' }
      ],
      '3': [
        { id: 'm6', name: 'Carlos Mendez', origin_country: 'Colombia', years_of_service: 8, church_id: '3' },
        { id: 'm7', name: 'Sophie Lambert', origin_country: 'France', years_of_service: 6, church_id: '3' },
        { id: 'm8', name: 'Ravi Patel', origin_country: 'India', years_of_service: 4, church_id: '3' }
      ]
    };

    setChurches(sampleChurches);
    setMissionaries(sampleMissionaries);
    setLoading(false);
  }, [region]);

  return { churches, missionaries, loading };
};
